export default __webpack_public_path__ + "static/media/sage-logo-login.b8e5be11.png";